import _ from 'lodash'
import groupType from 'scoreboard/admin/principals/groups/group-type'
import icon from 'scoreboard/components/icon'

/**
 * @returns {string} concatenation of type and ID and therefore
 * the authoritative comparison value for a principal
 */
const hashCode = function(p) {
	return `${p.type}${p.id}`
}

const principals = {

	hashCode,

	/**
	 * @returns {Map<String, Principal>} a map of principals keyed by {@link hashCode}
	 */
	toMap(principalsList) {
		return new Map(_.map(principalsList, it => [hashCode(it), it]))
	},

	/**
	 * @returns {boolean} true if the principals represent the same user or group
	 */
	equals(p1 = {}, p2 = {}) {
		return hashCode(p1) === hashCode(p2)
	},

	/**
	 * @param principals Principal.java
	 * @param className the classname to apply to each span tag that contains the label(s)
	 * @return A string of divs with the principal label and group type labels if available, example: John Doe (Administrators)
	 */
	toHtml(principals) {
		return _.reduce(principals, (html, p) => {

			let avatar = p.type === 'group' ? 'profile' : 'user-avatar'
			html += '<div class="principal-container">' +
				`<div class="avatar default-avatar">${icon(avatar)}</div>` +
				`<div class="label"><span class="principal">${_.escape(p.label)}</span>` +
				`${this.buildGroupTypeLabel(p)}</div></div>`
			return html
		}, '')
	},

	buildGroupTypeLabel(principal) {
		let label = ''
		if (principal.type === 'group') {
			let groupTypeLabel = groupType.label(principal.groupType)
			label = `<span class="post-label group-type">(${_.escape(groupTypeLabel)})</span>`
		}
		return label
	},

	/**
	 *
	 * @param principal
	 * @returns {Object} a new copy of principal with additional attributes needed
	 * to render the item (e.g. icon, groupTypeLabel)
	 */
	addViewContextAttributes(principal) {
		return _.extend({
			icon: this.getIconForType(principal.type),
			groupTypeLabel: groupType.label(principal.groupType)
		}, principal)
	},

	getIconForType(type) {
		let iconByType = {
			'group': 'profile',
			'user': 'user-avatar',
			'setupBy': 'user-avatar',
			'rollup-tree-group': 'rollup-tree'
		}
		return iconByType[type]
	}
}

export default principals
principals.__filename__ = 'components/principals.js'
